import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { ServiceMarquee } from "@/components/landing/ServiceMarquee";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { Services } from "@/components/landing/Services";
import { LeadForm } from "@/components/landing/LeadForm";
import { Footer } from "@/components/landing/Footer";

export default function Landing() {
  return (
    <main className="bg-[#F7F9FC] text-left">
      <Navbar />
      <Hero />
      <ServiceMarquee />
      <HowItWorks />
      <Services />
      <LeadForm />
      <Footer />
      <div className="fixed bottom-0 left-0 right-0 z-40 p-3 md:hidden bg-gradient-to-t from-[#F7F9FC] via-[#F7F9FC]/90 to-transparent">
        <a
          href="#solicitar"
          data-testid="mobile-sticky-cta"
          className="btn-cta block w-full text-center bg-[#2E9FDB] text-[#06305F] font-heading font-bold text-sm py-3.5 rounded-full uppercase tracking-wide"
        >
          Solicitar atendimento
        </a>
      </div>
    </main>
  );
}
